import { action, makeObservable, observable, IObservableArray } from 'mobx';
import { plainToInstance } from 'class-transformer';
import { ModelPromotion } from '~/models/model.promotion';

export class PromotionsService {
    public promotions: IObservableArray<ModelPromotion> = observable.array([]);

    constructor() {
        makeObservable(this);
        this.getPromotions();
    }

    @action
    getPromotions = async () => {
        try {
            /*const response: AxiosResponse = await api.get<ModelPromotion[]>(EApiUrl.promotion);
        if (response.statusText?.toLowerCase() === 'ok') {
          const promotions = plainToInstance(ModelPromotion, response.data);
          this.setPromotions(promotions);
        }*/
            const data = [
                {
                    title: 'Play Mobile and Online Games That Rock!',
                    text: 'Our legendary lineup of games are ready to rock your world – whether you’re into Puzzle Games or Free Casinos, our portfolio has something for you!',
                    image: 'https://wgames.webmind28.com/assets/img/promo-main.png',
                    btnLink: 'https://wgames.webmind28.com/assets/img/promo-main.png',
                },
            ];
            const promotions = plainToInstance(ModelPromotion, data);
            this.setPromotions(promotions);
        } catch (error: any) {}
    };

    @action
    setPromotions = (promotions: any) => {
        this.promotions.replace(promotions);
    };
}
